import { OpportunityTypeId } from 'types/savings';
import { createDialogWithIdStore } from '../createDialogWithIdStore';

export const useThresholdEditDialog = createDialogWithIdStore<{
  ids: number[],
  category: OpportunityTypeId,
  title: string,
}>();
